export const load = () => ({
	title: 'Custom Storm Windows Save Old Windows',
	showTitle: true,
});
